import { ADICIONAR_PASSAGEIROS_IDA } from '../types'

export default function adicionarPassageirosIda (passageiros) {
  return {
    type: ADICIONAR_PASSAGEIROS_IDA,
    payload: passageiros
  }
}
